// extracted by mini-css-extract-plugin
module.exports = {"preloader":"PrettyLoadPreloader_preloader__OccQU"};